import { theme } from '../../../common/theme';
import { styled } from '../../../providers/context/StyletronProvider/withStyletronProvider';

export const MainLayoutHeaderTitle = styled('h3', () => ({
  ...theme.fonts.titleMedium,
}));
